import {
    DEALERSUMMARYEXCELPDFFILE_FAILED,
    DEALERSUMMARYEXCELPDFFILE_SUCCESS,
    RESET_DEALERSUMMARYEXCELPDFFILE,
    LOADING_DEALERSUMMARYEXCELPDFFILE,
    NETWORK_ERROR_DEALERSUMMARYEXCELPDFFILE
} from '../types/index'

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERSUMMARYEXCELPDFFILE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERSUMMARYEXCELPDFFILE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERSUMMARYEXCELPDFFILE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERSUMMARYEXCELPDFFILE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERSUMMARYEXCELPDFFILE:
            return (state = initialState);
        default:
            return state;
    }
};